import React, { useState, useEffect } from "react";
import ConfirmBtn from "../../../Button/ConfirmBtn";
import AlertModal from "../../../Modal/AlertModal";
import { useApi } from "../../../../hooks/useApi";
import { toast } from "react-toastify";
import Loader from "../../../DefaultStyles/Loader";
import DefaultModalLayout, {
  ModalFixedBox,
} from "../../../Modal/DefaultModalLayout";
import { ModalLabel } from "../../Users/UserDetail/CommentModal/TargetContainer";
import Blank from "../../../DefaultStyles/Blank";

interface AllImmediatePayProps {
  fetch: () => void;
}

export default function AllImmediatePay({ fetch }: AllImmediatePayProps) {
  const [askAlert, setAskAlert] = useState(false);
  const [pay, setPay] = useState(false);
  const [result, setResult] = useState({
    modal: false,
    total: 0,
    success: 0,
  });

  const { response, loading, error } = useApi({
    method: "post",
    url: pay ? `pay/immetateAll` : undefined,
    data: {
      reason: " ",
    },
  });

  useEffect(() => {
    if (response?.status === 200 || response?.status === 201) {
      setResult({
        modal: true,
        total: response?.data?.total ?? 0,
        success: response?.data?.success ?? 0,
      });
      setPay(false);
      setAskAlert(false);
    }
  }, [response]);

  useEffect(() => {
    if (error) {
      toast.error(error?.data ?? "일괄 결제에 실패하였습니다.");
    }
  }, [error]);

  return (
    <>
      <ConfirmBtn
        btnText="일괄 결제"
        btnColor="mint"
        btnClickEvent={() => setAskAlert(true)}
      />

      {loading && <Loader />}

      {askAlert && (
        <AlertModal
          title={`일괄 결제 하시겠습니까?`}
          confirmText="결제"
          btnColor="mint"
          cancelEvent={() => setAskAlert(false)}
          confirmEvent={() => setPay(true)}
        />
      )}

      {result.modal && (
        <DefaultModalLayout
          closeEvent={() =>
            setResult((prev) => ({
              ...prev,
              modal: false,
            }))
          }
          modalTitle="일괄 결제 내역"
          confirmEvent={() => {
            setResult((prev) => ({
              ...prev,
              modal: false,
            }));
            fetch();
          }}
          confirmBtnText="확인"
          cancelBtn={<></>}
          isMediumModal={true}
        >
          <ModalFixedBox>총 {result.total}명</ModalFixedBox>

          <Blank blankHeight={14} />

          <ModalLabel>내용 확인</ModalLabel>

          <ModalFixedBox>결제 성공: {result.success}명</ModalFixedBox>

          <ModalFixedBox>
            결제 실패: {result.total - result.success}명
          </ModalFixedBox>
        </DefaultModalLayout>
      )}
    </>
  );
}
